import React from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';
import styled from 'styled-components';
import SocialLinks from './SocialLinks';
import Logo from '../assets/images/justbeastin-FINALUnivRed.png';

const FooterStyles = styled.footer`
    background-color: var(--black);
`;

const FooterContentStyles = styled.div`
    max-width: var(--container);
    margin: 0 auto;
    padding: 5rem 1.5rem;
    display: grid;
    --cols: 3;
    grid-template-columns: repeat(var(--cols), 1fr);
    gap: 7.5rem;
    color: var(--white);
    @media (max-width: 650px) {
        --cols: 1;
    }

    p {
        font-family: HammersmithOne;
        font-size: 1.8rem;
    }

    img {
        width: 100%;
        padding: 2rem 0;
    }

    svg {
        width: 10rem;
        fill: var(--white);
    }

    .footer__email {
        font-family: HammersmithOne;
        font-size: 2rem;
    }

    .footer__links {
        display: flex;
        flex-direction: column;
        font-family: HammersmithOne;
        font-size: 2rem;
    }
`;

export default function Footer() {
    const { site } = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    email
                }
            }
        }
    `);
    return (
        <FooterStyles>
            <FooterContentStyles>
                <div className="footer__content">
                    <h4>contact</h4>
                    <a href={`mailto:${site.siteMetadata.email}`} className="footer__email">{site.siteMetadata.email}</a>
                    <SocialLinks />
                </div>
                <div className="footer__content">
                    <h4>links</h4>
                    <div className="footer__links">
                        <Link to={'/'}>home</Link>
                        <Link to={'/about'}>about</Link>
                        <Link to={'/products'}>products</Link>
                    </div>
                </div>
                <div className="footer__content">
                    <img src={Logo} alt="I'm Just Beastin footer logo"/>
                    <p>Minneapolis, MN</p>
                    <p>&copy; Beastin {new Date().getFullYear()}</p>
                </div>
            </FooterContentStyles>
        </FooterStyles>
    )
}